import { render, staticRenderFns } from "./MenuAppearanceModal.vue?vue&type=template&id=0e8b07b2&scoped=true&"
import script from "./MenuAppearanceModal.vue?vue&type=script&lang=js&"
export * from "./MenuAppearanceModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuAppearanceModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MenuAppearanceModal.vue?vue&type=style&index=1&id=0e8b07b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b07b2",
  null
  
)

/* custom blocks */
import block0 from "./MenuAppearanceModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VCardTitle,VColorPicker,VDialog,VDivider,VFileInput,VFooter,VForm,VRow,VSelect,VSlider,VSubheader,VSwitch,VTab,VTabItem,VTabs,VTabsItems})
